// extracted by mini-css-extract-plugin
export default {"root":"uFIoxq6GmA5VaigFKRm0"};